import { makeStyles } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'none',
    '@media print': {
      backgroundColor: `${theme.palette.primary.main} !important`,
      color: '#FFF !important',
      padding: theme.spacing(1, 0),
      position: 'fixed',
      top: 0,
      display: 'block !important',
      width: '100%',
    },
  },
  logo: {
    height: 60,
    marginLeft: 20,
  },
}));

export default function Header() {
  const classes = useStyles();

  return (
    <header className={`${classes.header} pageHeader`}>
      <img src="/wp-content/themes/CCA/assets/images/logo-white.svg" alt="CCAoA logo" className={classes.logo} />
    </header>
  );
}
